import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    iconSection: {
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(3)
    },
    icon: {
        fontSize: 150
    },
    iconSuccess: {
        fontSize: 150,
        color: "darkgreen"
    },
    textSection: {
        width: "75%",
        marginBottom: theme.spacing(3),
        '& .MuiTypography-root': {
            fontSize: 20
        }
    },
    textHighlight: {
        fontWeight: 'bold',
        fontSize: 24        
    },
    form: {
        width: '100%',
        '& .MuiFormControl-root': {
            marginBottom: theme.spacing(1),
            width: '75%',
        },
        '& .MuiButton-root': {
            width: '75%',
            marginTop: theme.spacing(1)
        }
    },
    buttonContainer:{
        width: '100%',
        '& .MuiButton-root': {
            width: '75%',
            marginTop: theme.spacing(1)
        }
    }
}));

export default useStyles;